import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);
const KEY = "zf_cart_v1";

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem(KEY)) || [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    const add = (product, quantity = 1) => {
        setItems((prev) => {
            const found = prev.find((i) => i.product_id === product.id);
            if (found) {
                return prev.map((i) =>
                    i.product_id === product.id ? { ...i, quantity: Math.min(i.quantity + quantity, 20) } : i,
                );
            }
            return [
                ...prev,
                {
                    product_id: product.id,
                    name: product.name,
                    price_cents: product.price_cents,
                    image: product.storage_path,
                    quantity,
                },
            ];
        });
    };

    const setQuantity = (productId, quantity) =>
        setItems((prev) =>
            quantity <= 0
                ? prev.filter((i) => i.product_id !== productId)
                : prev.map((i) => (i.product_id === productId ? { ...i, quantity: Math.min(quantity, 20) } : i)),
        );

    const remove = (productId) => setItems((prev) => prev.filter((i) => i.product_id !== productId));
    const clear = () => setItems([]);

    const count = items.reduce((s, i) => s + i.quantity, 0);
    const totalCents = items.reduce((s, i) => s + i.price_cents * i.quantity, 0);

    const value = useMemo(
        () => ({ items, add, setQuantity, remove, clear, count, totalCents }),
        [items],
    );
    return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export default CartProvider;
